import React from "react";
import { NavLink } from "react-router-dom";
import "./style/footer.css"
import insta_icon from "../assets/footer/icons_footer/insta.svg"
import fb_icon from "../assets/footer/icons_footer/facebook.svg"
import twitter_ico from "../assets/footer/icons_footer/twitter.svg"
import linkedin_icon from "../assets/footer/icons_footer/linkedin.svg";
import ReactSVG from 'react-svg';

export default ({SideList }) => (
  <div style={{ display:"grid"}}> 
    <NavLink to="/" className="itemMenuMobile" exact={true}>À PROPOS</NavLink>
    <NavLink to="/solutions" className="itemMenuMobile" exact={true}>SOLUTIONS</NavLink>
    <NavLink to="/medias" className="itemMenuMobile" exact={true}>MÉDIAS</NavLink>
    <NavLink to="/carrieres" className="itemMenuMobile" exact={true}>CARRIÈRES</NavLink>
    <NavLink to="/blog" className="itemMenuMobile" exact={true}>BLOG</NavLink>
    <NavLink to="/contact" className="itemMenuMobile" exact={true}>CONTACT</NavLink>
    <div className="divImgFooterMenu">
        <div>
            <a href="https://www.instagram.com/chifco_iot/" rel="noopener noreferrer" target="_blank">
              <ReactSVG src={insta_icon} />
            </a>
          </div>
          <div >
            <a href="https://twitter.com/bechifco" rel="noopener noreferrer" target="_blank">
              <ReactSVG src={twitter_ico} />
          </a>
        </div>  
        <div >
          <a href="https://www.facebook.com/chifco/" rel="noopener noreferrer" target="_blank"><ReactSVG src={fb_icon} /></a>
        </div>
        <div >
          <a href="https://www.linkedin.com/company/chifco/?originalSubdomain=fr" rel="noopener noreferrer" target="_blank"><ReactSVG src={linkedin_icon} /></a>
        </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/home/SideList.js